/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ free_trial_day: NonNullable<unknown> }} Btn_Free_TrialInputs */

const en_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Free trial for ${i?.free_trial_day} days`)
};

const ar_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تجربة مجانية لمدة ${i?.free_trial_day} يوم`)
};

const de_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kostenlose Testphase für ${i?.free_trial_day} Tage`)
};

const es_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prueba gratuita durante ${i?.free_trial_day} días`)
};

const fr_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Essai gratuit pendant ${i?.free_trial_day} jours`)
};

const it_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prova gratuita per ${i?.free_trial_day} giorni`)
};

const ja_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day}日間の無料トライアル`)
};

const ko_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day}일 동안 무료 체험`)
};

const pt_br_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teste grátis por ${i?.free_trial_day} dias`)
};

const ru_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Бесплатный пробный период на ${i?.free_trial_day} дней`)
};

const th_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ทดลองใช้ฟรี ${i?.free_trial_day} วัน`)
};

const tr_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} gün boyunca ücretsiz deneme`)
};

const zh_cn_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费试用 ${i?.free_trial_day} 天`)
};

const zh_tw_btn_free_trial = /** @type {(inputs: Btn_Free_TrialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免費試用 ${i?.free_trial_day} 天`)
};

/**
* | output |
* | --- |
* | "Free trial for {free_trial_day} days" |
*
* @param {Btn_Free_TrialInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_free_trial = /** @type {((inputs: Btn_Free_TrialInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Free_TrialInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_free_trial(inputs)
	if (locale === "ar") return ar_btn_free_trial(inputs)
	if (locale === "de") return de_btn_free_trial(inputs)
	if (locale === "es") return es_btn_free_trial(inputs)
	if (locale === "fr") return fr_btn_free_trial(inputs)
	if (locale === "it") return it_btn_free_trial(inputs)
	if (locale === "ja") return ja_btn_free_trial(inputs)
	if (locale === "ko") return ko_btn_free_trial(inputs)
	if (locale === "pt_br") return pt_br_btn_free_trial(inputs)
	if (locale === "ru") return ru_btn_free_trial(inputs)
	if (locale === "th") return th_btn_free_trial(inputs)
	if (locale === "tr") return tr_btn_free_trial(inputs)
	if (locale === "zh_cn") return zh_cn_btn_free_trial(inputs)
	return zh_tw_btn_free_trial(inputs)
});